import { Component, EventEmitter, HostListener, inject, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CategoryService } from 'src/app/services/category/category.service';
import { LanguagesService } from 'src/app/services/languages/languages.service';
// import { faPenToSquare, faXmark, faPlus } from "@fortawesome/angular-fontawesome"
import { AdminService } from 'src/app/services/admin/admin.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LanguageSelectorComponent } from 'src/app/components/layout/language-selector/language-selector.component';
import { CommonModule } from '@angular/common';
import { ErrorComponent } from 'src/app/components/layout/error/error.component';
import { SpinnerComponent } from "../../../layout/spinner/spinner.component";

@Component({
  selector: 'app-app-category',
  standalone: true,
  imports: [
    LanguageSelectorComponent,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    TranslateModule,
    ErrorComponent,
    SpinnerComponent
],
  templateUrl: './app-category.component.html',
  styleUrls: ['./app-category.component.css']
})
export class AppCategoryComponent {

  @Output() reloadapps = new EventEmitter<void>();  // <-- Add this line
  @Input() isName = false
  @Input() isItems = false
  id = 0;
  categories: any[] = [];
  load = false;
  error = false;
  // addCategory = false;
  isCategoryLoad = false;
  isEdit = false;
  form!: FormGroup;

  editId = ''

  availableLanguages: any[] = [];
  selectedLanguage = '';
  isScrolling = false;

  deleteLoad = false

  // faPenToSquare = faPenToSquare
  // faXmark = faXmark
  // faPlus = faPlus
  userId = 0
  
  systemLang = ''

  private modalService = inject(NgbModal);
  modalRef: NgbModalRef | null = null;

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event): void {
    this.isScrolling = true;
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      this.isScrolling = false;
    }, 1000);
  }

  private scrollTimeout: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private AppService: CategoryService,
    private LanguagesService: LanguagesService,
    private fb: FormBuilder,
    private ToastrService: ToastrService,
    private adminService: AdminService,
    private CategoryService: CategoryService,
    private TranslateService: TranslateService
  ) {
    this.activatedRoute.params.subscribe(
      params => {
        if (params['id']) {
          this.id = params['id'];
        }
      }
    );
    this.LanguagesService.productCategoryLanguage$.subscribe(lang => {
      this.selectedLanguage = lang
    });
  

    this.LanguagesService.selectedLanguage$.subscribe(lang => {
      this.systemLang = lang.code
    })

    this.getCategories();
    this.initializeForm();
    this.addLanguageField();
 
  }

  
  open(content: TemplateRef<any>, category: any | null = null): void {
    this.modalRef = this.modalService.open(content, {
      backdropClass: 'light-blue-backdrop',
      scrollable: true
    });
  
    if (category) {
      this.editCategory(category); // როდესაც კატეგორია არის
    } else {
      this.isEdit = false;
      this.form.reset();
      this.form.setControl('titles', this.fb.array([])); // ახალი კატეგორიისთვის
      this.addLanguageField();
    }
  }


  initializeForm() {
    this.form = this.fb.group({
      id: [null],
      titles: this.fb.array([]),
      app_id: [this.id],
    });
    this.addLanguageField();
  }

  get titles(): FormArray {
    return this.form.get('titles') as FormArray;
  }

  addLanguageField(): void {
    // ვამოწმებთ, თუ ენა უკვე არსებობს titles-ის ჯგუფში
    const existingFieldIndex = this.titles.controls.findIndex(control => control.get('language')?.value === this.selectedLanguage);
    
    // თუ ენა არ არის, ვამატებთ ახალ ველს
    if (existingFieldIndex === -1) {
      this.titles.push(this.fb.group({
        language: [this.selectedLanguage, Validators.required],
        value: ['', Validators.required]
      }));
    }
  }

  getCategories() {
    this.load = true;
    this.CategoryService.getCategories(this.adminService.user.id.toString(), this.id.toString()).subscribe(
      (res: any) => {
        this.load = false;
        this.categories = res
        console.log('category', res)
        this.error = false;
        // this.reloadapps.emit()
      },
      (error: any) => {
        this.load = false;
        this.error = true;
        console.log(error)
      }
    );
  }


  editCategory(category: any): void {
    this.isEdit = true;
    this.editId = category.id;
  
    // ფორმის მონაცემების განახლება
    this.form.patchValue({
      id: category.id,
      app_id: category.app_id,  // თუ საჭიროა
    });
  
    const titlesArray = this.form.get('titles') as FormArray;
    titlesArray.clear(); // titles-ის გასუფთავება
  
    const titles = category.titles ? Object.keys(category.titles).map(key => ({
      language: key,
      value: category.titles[key]
    })) : [];
  
    // titles-ის დამატება
    titles.forEach((title: any) => {
      titlesArray.push(this.fb.group({
        language: [title.language, Validators.required],
        value: [title.value, Validators.required]
      }));
    });
  
    this.addLanguageField();
  }

  createOrUpdateCategory() {

    this.form.get('app_id')?.setValue(this.id);
    // console.log(this.form.invalid)
    // if (this.form.invalid) {
    //   return;
    // }
    

    const user_id = this.adminService.user.id

    const titles: { [key: string]: string } = {};
    this.form.value.titles.forEach((title: any) => {
      titles[title.language] = title.value;
    });

    const categoryData = {
      ...this.form.value,
      titles,
      user_id
    };

    this.isCategoryLoad = true;
    this.AppService.createOrUpdateCategory(categoryData).subscribe(
      (res: any) => {
        console.log(res)
        this.isCategoryLoad = false;
        this.modalRef?.close();
        // this.getCategories();
      },
      (error: any) => {
        this.isCategoryLoad = false;
        this.error = true;
        console.log(error)
      }
    );
  }

  deleteCategory(catId: number) {
    if (confirm( this.TranslateService.instant('ARE_YOU_SURE_DELETE') )) {
      this.deleteLoad = true
      this.AppService.deleteCategory(this.adminService.user.id.toString(), this.id.toString(), catId.toString()).subscribe(
        (res: any) => {
          // console.log(res)
          this.deleteLoad = false
          this.modalRef?.close();

        },
        (error: any) => {
          // console.log(error)
          this.deleteLoad = false

        }
      )
    }
  }
}